import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Column, ColumnContainer } from "./Columns.styles";
// eslint-disable-next-line react/jsx-no-useless-fragment
var ColumnBody = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
var column = {
    columnCount: 3
};
var ThreeColumns = function(param) {
    var children = param.children;
    var ref = _sliced_to_array(children(ColumnBody, ColumnBody, ColumnBody), 3), columnContent1 = ref[0], columnContent2 = ref[1], columnContent3 = ref[2];
    return /*#__PURE__*/ _jsxs(ColumnContainer, {
        children: [
            /*#__PURE__*/ _jsx(Column, _object_spread_props(_object_spread({}, column), {
                children: columnContent1
            })),
            /*#__PURE__*/ _jsx(Column, _object_spread_props(_object_spread({}, column), {
                children: columnContent2
            })),
            /*#__PURE__*/ _jsx(Column, _object_spread_props(_object_spread({}, column), {
                children: columnContent3
            }))
        ]
    });
};
export { ThreeColumns };
